import { render } from "./Innovation.vue?vue&type=template&id=8d7480ec&ts=true"
import script from "./Innovation.vue?vue&type=script&lang=ts"
export * from "./Innovation.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__